import React from 'react';
import { Spin } from 'antd';

interface PageLoadingProps {
  /** Full viewport (login / blank layouts). Default: fill content area. */
  fullPage?: boolean;
}

/**
 * Fallback while a lazy route chunk is loading.
 */
const PageLoading: React.FC<PageLoadingProps> = ({ fullPage = false }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: fullPage ? '100vh' : 280,
      width: '100%',
    }}
  >
    <Spin size="large" />
  </div>
);

export default PageLoading;
